import {  Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { environment } from 'src/environments/environment';

@Component({
    template:""
})
export abstract class BaseScrollingComponent {

    currentPosition;

    isScrolledBottom(event:Event, additionalThreshold:number = 1){
        let element = (event.target as HTMLElement)

        const atBottom = this.isAtBottom(element, additionalThreshold)
        let isScrollingDown = this.isScrollingDown(element);

        if(atBottom && isScrollingDown ){
            return true;
        } else {
            return false;
        }
    }

    isAtBottom(element:HTMLElement, additionalThreshold:number){
        return (element.offsetHeight + element.scrollTop) + additionalThreshold >= element.scrollHeight
    }

    isScrollingDown(element: HTMLElement){
        let scroll = element.scrollTop;
        let result;
        if (scroll > this.currentPosition) {
            result = true;
        } else {
            result = false;
        }
        this.currentPosition = scroll;
        return result;
    }
}